import auth from './auth';
import dayjs from 'dayjs';
import advancedSetting from './advancedSetting';

const SET_LANGUAGE = 'SET_LANGUAGE';
const SET_ALL_FALSE = 'SET_ALL_FALSE';
const SET_INDICATOR = 'SET_INDICATOR';
const SET_SPINNER = 'SET_SPINNER';

const dateStart = dayjs(new Date())
	.set('hour', 0)
	.set('minute', 0)
	.set('second', 0)
	.format('YYYY/MM/DD HH:mm:ss');

const dateEnd = dayjs(new Date())
	.set('hour', 23)
	.set('minute', 59)
	.set('second', 59)
	.format('YYYY/MM/DD HH:mm:ss');

export default {
	namespaced: true,
	state: {
		lang: 'ja',
		showDetector: null,
		showTrainer: null,
		showHistory: null,
		showModel: null,
		isSetting: null,
		spinner: false,
		namePage: '',
		selectedImage: {},
	},
	actions: {
		modifyLanguage({ commit }, payload) {
			commit(SET_LANGUAGE, payload.lang);
		},

		setAllFalse({ commit }) {
			commit(SET_ALL_FALSE);
		},

		setIndicator({ commit }, payload) {
			commit(SET_ALL_FALSE);
			commit(SET_INDICATOR, payload);
		},
		setSpinner({ commit }, payload) {
			commit(SET_SPINNER, payload);
		},
	},
	mutations: {
		SET_LANGUAGE(state, payload) {
			state.lang = payload;
		},

		/**
		 * set all show* to be false
		 * @param {Object} state
		 */
		SET_ALL_FALSE(state) {
			let keys = Object.keys(state);
			keys.forEach((key) => {
				if (key.includes('show')) state[key] = false;
			});
		},

		SET_INDICATOR(state, payload) {
			state[payload] = true;
		},

		SET_SPINNER(state, payload) {
			state.spinner = payload;
		},
		SET_NAME_PAGE(state, payload) {
			state.namePage = payload;
		},
		SET_SELECTED_IMAGE(state, payload) {
			state.selectedImage = payload;
		},
		SET_CONTENT_ADVANCE_SETTING(state, payload) {
			state.advancedSetting = payload;
		},
	},
	modules: {
		auth,
		advancedSetting,
	},
};
